import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
import { isString } from 'lodash';

@Pipe({ name: 'movementwritingdate' })
export class SLMovementWritingDatePipe implements PipeTransform {

  constructor() { }

  transform(value: any, ...args: any[]) {
    if (value === null || value === undefined) {
      return '';
    }

    if (isString(value)) {
      return moment(value).format('DD/MM/YYYY');
    }

    // Return empty string if no date was formatted
    return '';
  }
}
